import {useEffect, useState, useCallback} from 'react';
import {useForm} from "react-hook-form";
import apiClient from "../../../../utils/apiClient";
import FormSelect from "../../../forms/form-control/FormSelect";
import FormSubmitButton from "../../../forms/form-control/FormSubmitButton";
import FormInputDate from "../../../forms/form-control/FormInputDate";
import FormInputText from "../../../forms/form-control/FormInputText";

/**
 * Filter component for Dailies Search
 * @returns {JSX.Element}
 * @constructor
 */
const DailiesSearchFilters = (prop) => {
    const {register, handleSubmit, errors, setValue} = useForm();
    const {filters, setFilters, setTableData, setTableDataDisciplineId} = prop;
    const [disciplines, setDisciplines] = useState([]);
    const [rigs, setRigs] = useState([]);
    const updateReportFilters = useCallback((id, value) => {
        setFilters(prevState => ({
            ...prevState,
            [id]: value
        }));
    },[setFilters]);

    // filter selection handler
    const filterSelectionHandler = (e) => {
        const {id, value} = e.target;
        updateReportFilters(id, value);
    }

    // discipline selection handler
    const disciplineSelectionHandler = (e) => {
        const {id, value} = e.target;
        updateReportFilters(id, value);
        setValue('rig_id', null);
        updateReportFilters('rig_id', null);

        // get Rigs by Discipline Id
        apiClient
            .post('getAllActiveRigsByDisciplineId', {'discipline_id': value})
            .then(response => {
                const rigItems = response.data.rigs.map(
                    ({id, name}) => ({id: id, name: name})
                );
                setRigs(rigItems);
            });
    }

    const onSubmit = () => {
        updateReportFilters('isLoading', true);
        updateReportFilters('isSubmitted', true);

        apiClient
            .post('searchDailies', {
                date_from: filters.date_from,
                date_to: filters.date_to,
                discipline_id: filters.discipline_id,
                rig_id: filters.rig_id,
                keyword: filters.keyword,
            })
            .then(response => {
                setTableDataDisciplineId(filters.discipline_id);
                if (Object.keys(response.data).length === 0) {
                    setTableData([]);
                    return;
                }

                setTableData(response.data);
            })
            .catch(function () {
                setTableDataDisciplineId(filters.discipline_id);
                setTableData([]);
            }).then(function () {
            updateReportFilters('isLoading', false);
        });
    }

    // get filters data
    useEffect(() => {
        //get Disciplines
        apiClient
            .get('getDisciplines')
            .then(response => {
                const disciplineItems = response.data.disciplines.map(
                    ({id, name}) => ({id: id, name: name})
                );
                setDisciplines(disciplineItems);
            });

            setValue('keyword', '');
    }, [setValue]);

    return (
        <form
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row row s-gy">
                <FormSelect
                    id="discipline_id"
                    label="Discipline"
                    className="col-xs-12 col-sm-2 col-md-3 col-lg-2"
                    value={filters.discipline_id}
                    onChange={disciplineSelectionHandler}
                    options={disciplines}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormSelect
                    id="rig_id"
                    label="Rig"
                    className="col-sm-1"
                    value={filters.rig_id}
                    onChange={filterSelectionHandler}
                    options={rigs}
                    register={register()}
                    errors={errors}
                />
                <FormInputDate
                    id="date_from"
                    label="Start Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.date_from}
                    onChange={filterSelectionHandler}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormInputDate
                    id="date_to"
                    label="End Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.date_to}
                    onChange={filterSelectionHandler}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormInputText
                    id="keyword"
                    label="Keyword"
                    className="col-sm-3"
                    value={filters.keyword}
                    onChange={filterSelectionHandler}
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormSubmitButton
                    className="col-md-q"
                    label="Show"
                />
            </div>
        </form>
    );
}

export default DailiesSearchFilters;
